import { DataTable } from '@/components/ui/DataTable';
import type { AdminExecution } from '@/types/admin.types';
import { formatRelativeTime, formatDuration } from '@/utils/formatters';
import { createColumnHelper } from '@tanstack/react-table';
import { useNavigate } from 'react-router-dom';
import { ExecutionStatusSummary } from './ExecutionStatusSummary';

const columnHelper = createColumnHelper<AdminExecution>();

const columns = [
  columnHelper.accessor('templateName', {
    header: 'Template',
    cell: (info) => <span className="font-medium text-neutral-900 dark:text-neutral-200">{info.getValue()}</span>,
  }),
  columnHelper.accessor('domainName', {
    header: 'Domaine',
    cell: (info) => <span className="text-neutral-600 dark:text-neutral-400">{info.getValue()}</span>,
  }),
  columnHelper.accessor('folderName', {
    header: 'Dossier',
    cell: (info) => <span className="text-neutral-600 dark:text-neutral-400 text-xs">{info.getValue()}</span>,
  }),
  columnHelper.accessor('organisationName', {
    header: 'Organisation',
    cell: (info) => <span className="text-neutral-500 text-xs">{info.getValue()}</span>,
  }),
  columnHelper.accessor('status', {
    header: 'Statut',
    cell: (info) => (
      <ExecutionStatusSummary execution={info.row.original} compact />
    ),
  }),
  columnHelper.accessor('duration', {
    header: 'Durée',
    cell: (info) => <span className="text-xs text-neutral-500">{info.getValue() != null ? formatDuration(info.getValue()!) : '--'}</span>,
  }),
  columnHelper.accessor('startedAt', {
    header: 'Début',
    cell: (info) => <span className="text-xs text-neutral-500">{info.getValue() ? formatRelativeTime(info.getValue()) : '--'}</span>,
  }),
];

interface ExecutionsTableProps {
  data: AdminExecution[];
  loading?: boolean;
}

export function ExecutionsTable({ data, loading }: ExecutionsTableProps) {
  const navigate = useNavigate();
  return (
    <DataTable
      columns={columns}
      data={data}
      loading={loading}
      onRowClick={(row) => navigate(`/automations/executions/${row.uuid}`)}
      emptyMessage="Aucune exécution trouvée"
    />
  );
}
